import { ReactElement } from 'react'
import { Barcode } from '../Barcode'
import {
  Container, Description, InformationLabel, Name, NameLabel,
} from './TagSection.style'

interface TagSectionProps {
    flexSize?: number,
    name: string,
    description?: string,
    value: string,
    footer?: ReactElement<any, any>,
    hasBorders?: boolean
  }

const TagSection = (props: TagSectionProps): JSX.Element => {
  const {
    flexSize, name, description, value, footer, hasBorders,
  } = props

  const resolveDescription: string = description || value

  return (
    <Container flexSize={flexSize} hasBorders={hasBorders}>
      <NameLabel>
        <Name>{name}</Name>
      </NameLabel>
      <InformationLabel>
        <Description>{resolveDescription}</Description>
        <Barcode value={value} format='CODE128' />
        {footer}
      </InformationLabel>
    </Container>
  )
}

export { TagSection }
